import { GetOktaTokenInput } from './api/Authentication.gql';

// Config type
export type Config = {
  digitalOkta: GetOktaTokenInput;
  bffUrl: string | undefined;
};

export enum Environment {
  Production = 'production',
  UAT = 'uat'
}

// Export the basic configuration
export const config: Config = {
  digitalOkta: {
    clientId: '',
    clientSecret: '',
    grantType: '',
    scope: ''
  },

  // BFF
  bffUrl: process.env.REACT_APP_BFF_URL
};

export function getBffUrl(): string {
  return config.bffUrl !== undefined ? config.bffUrl : '';
}
